var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { gql } from '@apollo/client';
export var GET_PROMOBAR = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query GetCmsPage($identifiers: [String]!) {\n        cmsBlocks(identifiers: $identifiers) {\n            items {\n                content\n            }\n        }\n    }\n"])));
export default {
  getPromoBarQuery: GET_PROMOBAR.inner
};